const routerHR = {
    "releases": {
        "view": {
            "name": "Izdanja",
            "buttonText": "Dodaj Novo Izdanje",
            "secondaryButtonText": "Prenesi Izdanje",
            "headerText": "Izdanja"
        },
        "add": {
            "name": "Dodaj Novo Izdanje",
            "headerText": "Izdanja"
        },
        "update": {
            "name": "Ažuriraj Izdanje",
            "headerText": "Izdanja"
        },
        "details": {
            "name": "Detalji Izdanja",
            "headerText": "Izdanja"
        },
        "transfer": {
            "name": "Prenesi Izdanje",
            "headerText": "Izdanja"
        },
        "tracks": {
            "name": "Popis Pjesama",
            "headerText": "Izdanja"
        },
        "deliveryConfirmation": {
            "name": "Popis Dostavljenih",
            "headerText": "Popis Dostavljenih"
        },
        "storeDeliveryList": {
            "name": "Popis Dostava Trgovine",
            "headerText": "Popis Dostava Trgovine"
        }
    },
    "copyrightInfringements": {
        "view": {
            "name": "Povrede Autorskih Prava",
            "headerText": "Povrede Autorskih Prava"
        }
    },
    "escrowWallet": {
        "view": {
            "name": "Escrow Novčanik",
            "headerText": "Escrow Novčanik"
        }
    },
    "artists": {
        "view": {
            "name": "Umjetnici",
            "buttonText": "Dodaj Novog Umjetnika",
            "headerText": "Umjetnici"
        },
        "add": {
            "name": "Dodaj Novog Umjetnika",
            "headerText": "Umjetnici"
        },
        "update": {
            "name": "Ažuriraj Umjetnika",
            "headerText": "Umjetnici"
        },
        "viewDetails": {
            "name": "Pogledaj Detalje Umjetnika",
            "headerText": "Pogledaj Detalje Umjetnika"
        },
        "wishlist": {
            "name": "Lista Želja Umjetnika",
            "headerText": "Lista Želja Umjetnika"
        },
        "addFromWishlist": {
            "name": "Dodaj Umjetnika s Liste Želja",
            "headerText": "Dodaj Umjetnika s Liste Želja"
        }
    },
    "trends": {
        "view": {
            "name": "Trendovi",
            "headerText": "Trendovi"
        }
    },
    "earningsDrilldown": {
        "view": {
            "name": "Zarada",
            "headerText": "Detalji Zarade"
        }
    },
    "accounting": {
        "view": {
            "name": "Pametno Računovodstvo",
            "headerText": "Pametno Računovodstvo",
            "buttonText": "Dodaj Novo Računovodstvo"
        },
        "add": {
            "name": "Dodaj Novo Računovodstvo",
            "headerText": "Dodaj Novo Računovodstvo"
        },
        "breakdown": {
            "name": "Računovodstveni Pregled",
            "headerText": "Računovodstveni Pregled"
        }
    },
    "invoices": {
        "view": {
            "name": "Računi",
            "headerText": "Računi",
            "buttonText": "Dodaj Račun"
        },
        "add": {
            "name": "Dodaj Račun",
            "headerText": "Dodaj Račun"
        }
    },
    "musicLink": {
        "view": {
            "name": "Glazbena Poveznica",
            "buttonText": "Dodaj Novu Glazbenu Poveznicu",
            "headerText": "Glazbena Poveznica",
            "secondaryButtonText": "URL Glazbene Poveznice"
        },
        "add": {
            "name": "Dodaj Glazbenu Poveznicu",
            "headerText": "Glazbena Poveznica"
        },
        "update": {
            "name": "Ažuriraj Glazbenu Poveznicu",
            "headerText": "Glazbena Poveznica"
        },
        "viewStats": {
            "name": "Statistika Pregleda Glazbene Poveznice",
            "headerText": "Statistika Pregleda Glazbene Poveznice"
        }
    },
    "musicLinkUrlpart": {
        "view": {
            "name": "Dio URL-a Glazbene Poveznice",
            "buttonText": "Dodaj Novi Dio URL-a Glazbene Poveznice",
            "headerText": "Dio URL-a Glazbene Poveznice"
        },
        "add": {
            "name": "Dodaj Novi Dio URL-a Glazbene Poveznice",
            "headerText": "Dio URL-a Glazbene Poveznice"
        },
        "update": {
            "name": "Ažuriraj Dio URL-a Glazbene Poveznice",
            "headerText": "Dio URL-a Glazbene Poveznice"
        }
    },
    "linkLandingPage": {
        "view": {
            "name": "Odredišna Stranica Poveznice",
            "buttonText": "Dodaj Odredišnu Stranicu Poveznice",
            "headerText": "Odredišna Stranica Poveznice"
        },
        "add": {
            "name": "Dodaj Odredišnu Stranicu Poveznice",
            "headerText": "Odredišna Stranica Poveznice"
        },
        "update": {
            "name": "Ažuriraj Odredišnu Stranicu Poveznice",
            "headerText": "Odredišna Stranica Poveznice"
        },
        "viewAnalytics": {
            "name": "Analitika Odredišne Stranice Poveznice",
            "headerText": "Odredišna Stranica Poveznice"
        }
    },
    "mastering": {
        "view": {
            "name": "Mastering",
            "buttonText": "Dodaj Mastering",
            "headerText": "Audio Mastering"
        },
        "add": {
            "name": "Dodaj Mastering",
            "headerText": "Audio Mastering"
        },
        "update": {
            "name": "Ažuriraj Mastering",
            "headerText": "Audio Mastering"
        },
        "viewSongs": {
            "name": "Pjesme za Audio Mastering",
            "headerText": "Pjesme za Audio Mastering"
        }
    },
    "featureRequest": {
        "view": {
            "name": "Zahtjev za Značajku",
            "buttonText": "Novi Zahtjev za Značajku",
            "headerText": "Zahtjev za Značajku"
        },
        "add": {
            "name": "Dodaj Zahtjev za Značajku",
            "headerText": "Zahtjev za Značajku"
        }
    },
    "scWhitelist": {
        "view": {
            "name": "SC Bijela Lista",
            "headerText": "SC Bijela Lista"
        }
    },
    "profile": {
        "view": {
            "name": "Profil",
            "headerText": "Moj Profil"
        }
    },
    "announcements": {
        "view": {
            "name": "Obavijesti",
            "headerText": "Obavijesti"
        }
    },
    "twoFactorAuthentication": {
        "view": {
            "name": "Dvofaktorska Autentifikacija",
            "headerText": "Dvofaktorska Autentifikacija"
        }
    },
    "completeYourInformation": {
        "view": {
            "name": "Dovršite Svoje Informacije",
            "headerText": "Dovršite Svoje Informacije"
        }
    },
    "tokens": {
        "view": {
            "name": "Tokeni",
            "headerText": "Tokeni"
        }
    },
    "orderTokens": {
        "view": {
            "name": "Naruči tokene",
            "headerText": "Naruči tokene"
        }
    },
    "accessKeys": {
        "view": {
            "name": "Pristupni ključevi",
            "headerText": "Pristupni ključevi"
        }
    },
    "paymentMethods": {
        "view": {
            "name": "Načini Plaćanja",
            "buttonText": "Dodaj Način Plaćanja",
            "headerText": "Moji Načini Plaćanja"
        },
        "add": {
            "name": "Dodaj Način Plaćanja",
            "headerText": "Moji Načini Plaćanja"
        },
        "update": {
            "name": "Ažuriraj Način Plaćanja",
            "headerText": "Moji Načini Plaćanja"
        }
    },
    "orderCredits": {
        "view": {
            "name": "Naruči Kredite",
            "headerText": "Naruči Kredite"
        }
    },
    "purchaseHistory": {
        "view": {
            "name": "Povijest Kupovine",
            "headerText": "Povijest Kupovine"
        }
    },
    "subscription": {
        "view": {
            "name": "Moja Pretplata",
            "headerText": "Moja Pretplata"
        },
        "upgrade": {
            "name": "Nadogradi Pretplatu",
            "headerText": "Nadogradi Pretplatu"
        }
    },
    "subUsers": {
        "view": {
            "name": "Podkorisnici",
            "buttonText": "Dodaj Novog Podkorisnika",
            "headerText": "Moji Podkorisnici"
        },
        "add": {
            "name": "Dodaj Novog Podkorisnika",
            "headerText": "Moji Podkorisnici"
        },
        "edit": {
            "name": "Uredi Podkorisnika",
            "headerText": "Moji Podkorisnici"
        }
    },
    "labels": {
        "view": {
            "name": "Izdavačke Kuće",
            "buttonText": "Dodaj Novu Izdavačku Kuću",
            "headerText": "Moje Izdavačke Kuće"
        },
        "add": {
            "name": "Dodaj Novu Izdavačku Kuću",
            "headerText": "Moje Izdavačke Kuće"
        },
        "edit": {
            "name": "Uredi Izdavačku Kuću",
            "headerText": "Moje Izdavačke Kuće"
        }
    },
    "statements": {
        "view": {
            "name": "Izvještaji",
            "headerText": "Financijski Izvještaji"
        }
    },
    "subuserStatements": {
        "viewParentUser": {
            "name": "Izvještaji Podkorisnika",
            "headerText": "Izvještaji Podkorisnika"
        },
        "viewSubuser": {
            "name": "Izvještaji Korisnika",
            "headerText": "Izvještaji Korisnika"
        }
    },
    "dashboard": {
        "view": {
            "name": "Početna Stranica",
            "headerText": "Početna Stranica"
        }
    }
};

export default routerHR;